<template>
    <div class="sub-bannerbox">
        <div :class="[step ? 'sub-banner-step': 'sub-banner',$i18n.locale == 'zh' ? 'sub-banner-zh' : 'sub-banner-hk']">
            <div class="banner-cont">
                <div class="inset-lang">
                    <a :class="[($i18n.locale == 'hk') && 'current']" @click="$i18n.locale = 'hk'">繁</a>
                    <span>|</span>
                    <a :class="[($i18n.locale == 'zh') && 'current']" @click="$i18n.locale = 'zh'">简</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            step: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped lang="less">
    .sub-bannerbox {
        margin-bottom: 30px;
        .banner-cont {
            text-align: right;
            padding-top: 30px;
        }
        .inset-lang {
            a {
                font-weight: bold;
                color: #bcbcbc;
                font-size: 14px;
                cursor: pointer;
                &.current {
                    color: #0d79cd;
                }
            }
            span {
                margin: 0 5px;
                color: #bcbcbc
            }
        }
        .sub-banner {
            background: url(../../static/images/zindex-subbanner2.jpg) no-repeat center top/cover;
            height: 480px;
            .banner-cont {
                height: 100%;
                width: 1000px;
                margin: 0 auto;
            }
            &.sub-banner-hk {
                background: url(../../static/images/zindex-subbanner.jpg) no-repeat center top/cover;
            }
        }
        .sub-banner-step {
            background: url(../../static/images/zindex-subbanner2.jpg) no-repeat center top/cover;
            height: 480px;
            .banner-cont {
                height: 100%;
                width: 1000px;
                margin: 0 auto;
            }
            &.sub-banner-hk {
                background: url(../../static/images/zindex-subbanner.jpg) no-repeat center top/cover;
            }
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/components/subBanner.vue